// Constantes puras de MapPage (Atlas). Extraídas para poder testearlas
// sin renderizar la página completa (antd/styled-components/servicios).
// `SPAIN` representa la opción "toda España": id 0 = ADD_ALL_ID
// (definido en MapMunicipalitySearchForm).
export const SPAIN = { id: 0, name: 'España' }